<template>
  <app-panel
    subtitle="Experts à découvrir, méthodes de terrain et actus fortes, retrouvez le meilleur de Pollen dans votre inbox."
    title="Le meilleur de la formation, version Pollen"
  >
    <growth-contact-button
      block
      origin="blog"
      origin_page_action="newsletter_subscription_cta"
      :origin_page_id="post.id"
      size="lg"
    >
      Recevoir notre newsletter
    </growth-contact-button>
  </app-panel>
</template>

<script lang="ts" setup>
import type { BlogPostPage } from "~~/model/blog.model";

defineProps<{
  post: BlogPostPage;
}>();
</script>
